var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createApp } from "vue";
import FilterApp from './FilterApp.vue';
import { createPinia } from "pinia";
import { useFilterStore } from "./store";
import { updateHtml } from "../../components/pager";
import useFilterAPI from "./api";
import EventBus from "../../events/EventBus";
import { extractAppData } from "../../utils";
import { switchTabByCode } from "../../components/ajax_tabs";
var filterEl = document.getElementById('filter-app');
var notFoundMessage = document.getElementById('not-found-block');
var filterEnabled = !!filterEl;
function updateErrorMessage(show, isNew) {
    if (show) {
        notFoundMessage.querySelector('span[data-text-1]').innerText = isNew ? 'новых товаров' : 'товаров со скидкой';
        notFoundMessage.querySelector('span[data-text-2]').innerText = isNew ? 'новинки от других брендов' : 'самые популярные ароматы в нашей распродаже';
        notFoundMessage.classList.remove('hidden');
    }
    else {
        notFoundMessage.classList.add('hidden');
    }
}
function updatePageTitle(title) {
    if (title) {
        document.title = document.querySelector('h1').innerText = title;
    }
}
export default function initFilter() {
    var _a, _b;
    if (!filterEnabled) {
        return;
    }
    var html = (_a = document.querySelector('.catalog_items')) === null || _a === void 0 ? void 0 : _a.innerHTML;
    var pagerHtml = (_b = document.querySelector('[data-pagination]')) === null || _b === void 0 ? void 0 : _b.innerHTML;
    var title = document.querySelector('h1').innerText;
    var initialState = extractAppData(filterEl);
    var pinia = createPinia();
    var store = useFilterStore(pinia);
    var api = useFilterAPI();
    store.setInitialState(initialState);
    api.request('/api/filter/state').then(function () {
        var _a;
        store.setLoaded(false);
        createApp(FilterApp, {
            currentSort: (_a = document.getElementById('sorting').querySelector('.btn__label')) === null || _a === void 0 ? void 0 : _a.textContent,
        }).use(pinia).mount(filterEl);
        store.setValues(initialState.values);
        store.updateValues();
        store.setLoaded();
        var state = __assign(__assign({}, initialState), { html: html, pagerHtml: pagerHtml, title: title });
        window.history.replaceState(state, null, document.location.pathname + document.location.search);
    });
    EventBus.on('filter:page', function (data) {
        api.updateResults(false, { page: data.page, pager: true, loadMore: data.isMoreButton });
    });
    EventBus.on('tab:change', function (event) {
        store.config.md = event.code;
        store.config.global = event.global;
        store.config.url = event.url;
        store.values = {};
        updatePageTitle(event.pageTitle);
        api.updateResults(true, { url: event.url, lockFilter: true })
            .then(function () {
            if (store.config.mode === 'BRAND') {
                updateErrorMessage(event.global, event.code === 'NEW');
            }
        });
    });
    window.addEventListener('popstate', function (event) {
        var state = event.state;
        if (!(state && state.config && state.values && state.page)) {
            return;
        }
        updatePageTitle(state.title);
        if ((state.config.md && store.config.md) && store.config.md !== state.config.md) {
            switchTabByCode(state.config.md, false);
        }
        store.setInitialState(state);
        store.setSortType(state.config.sort);
        if (state.html) {
            updateHtml(state.html, false, state.pagerHtml);
        }
        else {
            api.updateResults(true, { page: state.page, pushState: false });
        }
    });
}
